// ABOUTME: Derives the configurator's forceFinalizeEnabled prop from a resolved product.
// ABOUTME: True when the model opted into finalizing incomplete configurations (the server flags the product).

import { ConfiguratorProduct } from './configuratorProduct';

/**
 * The server attaches forceFinalizeEnabled to the product returned by apply-assignments when the
 * model node has the flag set; false when the flag (or the product) is missing.
 */
export const getForceFinalizeEnabled = (product: ConfiguratorProduct | undefined): boolean =>
    !!product?.forceFinalizeEnabled;
